import React from "react";
import SkeletonLoader from "../dashboard/SkeletonLoader";

interface SidebarSkeletonLoaderProps {
  width?: string;
  height?: string;
  hasIcon?: boolean;
  hideText?: boolean;
}
const SidebarSkeletonLoader = (props: SidebarSkeletonLoaderProps) => {
  const { width, hasIcon, height, hideText } = props;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {hasIcon && <SkeletonLoader width="24px" height="24px" />}
      {!hideText && (
        <SkeletonLoader width={width} height={height ? height : "12px"} />
      )}
    </div>
  );
};

export default SidebarSkeletonLoader;
